import { Box, Text } from '@chakra-ui/react';
import { Divider } from '@time-line/components/common';
import type { ReactNode } from 'react';

interface BlogSectionHeadingProps {
  children: ReactNode;
  removeBorder?: boolean;
  id?: string;
}

export function BlogSectionHeading({
  children,
  removeBorder,
  id,
}: BlogSectionHeadingProps) {
  return (
    <Box>
      <Text id={id} as="h3" size="title2" py="2xs">
        {children}
      </Text>
      {!removeBorder && <Divider mb="m" />}
    </Box>
  );
}
